module.exports = __webpack_public_path__ + "img/introduce_interior.0fec8850.jpg";